// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"b9d681b1","239":"bf51d9ce","384":"0aeebda9","396":"3b9caeb6","453":"8fb35c44","455":"25200619","705":"3e73575a","794":"a40dacde","977":"80ea636f"}[chunkId] + ".chunk.js";
};